module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-message-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-message",
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('img', {
    staticClass: "el-message-icon",
    attrs: {
      "src": _vm.typeImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-message-group"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "el-message-closeBtn el-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0b22ce89!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/message/src/main.vue
// module id = 611
// module chunks = 0